var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTriangleS(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 10,
    viewBox: "0 0 24 10",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.6281 9.80276e-07C11.4227 9.64886e-07 11.257 0.166596 11.249 0.37183C11.0599 5.25247 7.15197 10 -1.01993e-06 10L24 10C16.8304 10 12.2331 5.22378 12.0086 0.371755C11.9991 0.166587 11.8335 9.95667e-07 11.6281 9.80276e-07Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTriangleS);
export default __webpack_public_path__ + "static/media/triangle-S.5141c39a5f23a8f59e242c8b6bdc3248.svg";
export { ForwardRef as ReactComponent };